import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track12ARed = ({ state, workState, onLabelClick }) => (
	<g id="Track12ARed" transform="translate(2255.000000, 181.000000)" className="track">
		<g id="line" transform="translate(0.000000, -0.000000)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
			 strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<line x1="11.560161" y1="66.0950399" x2="0.384032901" y2="1.06466754e-13"/>
			<TrackArrow transform="translate(11.134180, 63.955438) rotate(-104.000000) translate(-11.134180, -63.955438) "
									points="15.1341798 71.9554383 7.13417977 63.9554383 15.1341798 55.9554383"/>
			<path
				d="M39.2360066,263 L39.6417784,212.55383 C39.6988266,205.461501 39.0011775,198.383226 37.5606088,191.438505 L13.9458342,77.5959399 L13.9458342,77.5959399"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track12ARed')}
			coords="6.945224, 96.869087"
			text="12A"
			textCoordsX="7.58984375"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>

);

Track12ARed.propTypes = trackPropTypes;

export default Track12ARed;
